import styles from './PageMainTitle.module.scss'
import Breadcrumb from 'components/commons/Breadcrumb/Breadcrumb'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'

const tweenVars: gsap.TimelineVars = {
  y: '50',
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

interface Props {
  pageMainTitle: {
    category?: string
    title?: string
    titleJa?: string
    sub_title: string
    sub_title2: string
    text: string
    text2?: string
  }
  paths: {
    name: string
    url: string
  }[]
  isVertical?: boolean
  isRecruit?: boolean
}

const PageMainTitle: React.FC<Props> = ({ pageMainTitle, paths, isVertical = false, isRecruit }) => {
  const timeline = gsap.timeline()

  const wrapper = useRef<HTMLDivElement>(null)
  const color_box = useRef<HTMLDivElement>(null)
  const mini_title = useRef<HTMLSpanElement>(null)
  const main_title = useRef<HTMLSpanElement>(null)
  const title_ja = useRef<HTMLSpanElement>(null)
  const sub_title1 = useRef<HTMLHeadingElement>(null)
  const sub_title2 = useRef<HTMLHeadingElement>(null)
  const title_text = useRef<HTMLDivElement>(null)
  const title_text2 = useRef<HTMLDivElement>(null)

  useEffect(() => {
    gsap.from(color_box.current, {
      x: '-1100',
      duration: 3,
      opacity: 1,
      ease: Power4.easeOut,
    })

    timeline
      .to(wrapper.current, { css: { opacity: 1 } }, 0)
      .from(mini_title.current, tweenVars, 0.2)
      .from(main_title.current, tweenVars, 0.4)
      .from(title_ja.current, tweenVars, 0.4)
      .from(sub_title1.current, tweenVars, 0.6)
      .from(sub_title2.current, tweenVars, 0.6)
      .from(title_text.current, tweenVars, 0.8)
      .from(title_text2.current, tweenVars, 1)
  }, [])

  return (
    <section className={`${styles.mainTitle} color_box`} ref={wrapper}>
      <div className={styles.breadcrumbs}>
        <Breadcrumb paths={paths} />
      </div>
      <div className={`${styles.headding} ${isRecruit ? styles.headding__recruit : styles.headding__regular}`}>
        {isVertical ? (
          <h1 className={styles.headding_vertical}>
            <span className={styles.block} ref={mini_title}>
              {pageMainTitle.title}
            </span>
            <span className={styles.block} ref={main_title}>
              {pageMainTitle.category}
            </span>
          </h1>
        ) : (
          <h1 className={styles.headding_ttl}>
            {pageMainTitle.title && (
              <span ref={mini_title} className={styles.titleEn}>
                {pageMainTitle.title}
              </span>
            )}
            {pageMainTitle.category && (
              <span ref={main_title} className={styles.TitleSub}>
                {pageMainTitle.category}
              </span>
            )}
            {pageMainTitle.titleJa && (
              <span ref={title_ja} className={styles.TitleJa}>
                {pageMainTitle.titleJa}
              </span>
            )}
          </h1>
        )}
        {isRecruit && (
          <h2 className={styles.headding_subttl} ref={sub_title1}>
            期待を超えた価値を創造する
          </h2>
        )}
        {pageMainTitle.text && (
          <p className={styles.headding_desc} ref={title_text}>
            {pageMainTitle.text}
          </p>
        )}
      </div>
    </section>
  )
}
export default PageMainTitle
